module.exports = __webpack_public_path__ + "static/logo-vertical-light-2000x1643-932561ee2f8bb017b4054232f27a463d.png";